import React, { useContext, useEffect, useState } from 'react';
import '../components/Modal.css';
import { cancelFeedback, getCaptcha, saveFeedback } from '../api';
import Refresh from '../media/refresh.png';
import useCustomToast from '../components/Alert';
import DataContext from '../components/DataContext/DataContext';
import Modal from '../components/Modal';

const FeedbackView = ({ isOpen, onClose }) => {
  const { org, language, config} = useContext(DataContext);
  const [feedback, setFeedback] = useState('');
  const [captchaImg, setCaptchaImg] = useState('');
  const [remainingChars, setRemainingChars] = useState(250);
  const [captchaText, setCaptchaText] = useState('');
  const [feedbackError, setFeedbackError] = useState('');
  const [captchaError, setCaptchaError] = useState('');
  const [captchaReady, setCaptchaReady] = useState(false);
  const showToast = useCustomToast();
  const allStores = JSON.parse(localStorage.getItem('store'));
  let uniqueID = localStorage.getItem('uniqueID');

  const handleFeedbackChange = (e) => {
    const value = e.target.value;
    if (value.length <= 250) {
      setFeedback(value);
      setRemainingChars(250 - value.length);
      setFeedbackError('');
    }
  };

  const handleCaptchaChange = (e) => {
    setCaptchaText(e.target.value);
    setCaptchaError('');
  };

  useEffect(() => {
    if (isOpen) {
      genrateCaptcha();
    }
  }, [isOpen]);

  const handleRefrsh = () => {
    genrateCaptcha();
  };

  const genrateCaptcha = async () => {
    const data = {
      clientId: uniqueID
    };
    try {
      const response = await getCaptcha(org, data);
      if (response.status === 200) {
        setCaptchaImg(response.data.captcha);
        setCaptchaReady(true);
      }
    } catch (error) {
      if (error.response && error.response.status === 405) {
        onClose();
        showToast("Oops! It looks like you've hit your message limit for today. See you in 24 hours!", "error");
      }
      if (error.response && error.response.status === 401) {
        onClose();
        showToast("Invalid market - Please check market name", "error");
      }
      console.error('Error getting captcha:', error.message);
    }
  };

  const sendFeedback = async (org, data) => {
    try {
      const response = await saveFeedback(org, data);
      if (response.status === 200) {
        clearData();
        showToast("Feedback message submitted successfully", "success");
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        genrateCaptcha();
        setCaptchaText('');
        showToast("Invalid captcha - Please re-enter Captcha", "error");
      }
      if (error.response && error.response.status === 405) {
        showToast("Oops! It looks like you've hit your message limit for today. See you in 24 hours!", "error");
      }
      if (error.response && error.response.status === 400) {
        genrateCaptcha();
        setCaptchaText('');
        showToast("Please do not use < or > signs in the feedback message", "error");
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let hasError = false;
    const trimmedFeedback = feedback.trim();

    if (!trimmedFeedback) {
      setFeedbackError("Feedback message is required");
      hasError = true;
    }

    if (!captchaText) {
      setCaptchaError("Captcha is required");
      hasError = true;
    }

    if (hasError) {
      return;
    }

    let store = '';
   // let storeName=''
  
    if (allStores.length === 1) {
      store=config.storeCode.filter(item=>item.code===allStores[0]).map(item=>({storeName:item.info[language].name, store:item.code}))[0]
      // console.log(config,language,"config")
      // debugger
      // store = allStores[0];

    } else {
      store = {store:'-'};
    }
    debugger
    const data = {
      captcha: captchaText,
      feedbackMessage: trimmedFeedback,
      ...store,
      clientId: uniqueID,
      
    };

    sendFeedback(org, data);
  };
  const handleCancel = async () => {
    try {
        const response = await cancelFeedback(uniqueID);
      if (response.status === 200) {
        console.log("Cancelled successfully");
      }
    } catch (error) {
      console.log("Failed to cancel the operation", "error");
      console.error('Error cancelling operation:', error.message);
    }
    onClose(); // Ensure modal closes after handling the cancel action
  };
  const clearData = () => {
    setFeedback('');
    setCaptchaImg('');
    setCaptchaText('');
    setRemainingChars(250);
    onClose();
  };

  const captcha = `data:image/jpeg;base64,${captchaImg}`;

  return (
    <Modal
    isOpen={isOpen && captchaReady}
    onClose={clearData}
    onCancel={handleCancel}
    title="Feedback"
    onSubmit={handleSubmit}
    >
      <form onSubmit={handleSubmit}>
        <textarea
          value={feedback}
          onChange={handleFeedbackChange}
          rows="5"
          placeholder="Your feedback to your Food Operations Leader ...."
          className="custom-textarea"
        />
        {feedbackError && <div className="error-message fedback-error">{feedbackError}</div>}
        <div className="char-count">
          {remainingChars} characters remaining
        </div>
        <div style={{ clear: "both" }}></div>
        <div className='captchaDiv'>
          <img src={captcha} alt="Captcha" />
          <img src={Refresh} alt="Refresh captcha"
            onClick={handleRefrsh}
            className='refresh' />
        </div>
        <div className='inputDiv'>
          <input type="text" className="custom-input"
            placeholder="Enter the text shown in the image"
            value={captchaText}
            onChange={handleCaptchaChange} />
          {captchaError && <div className="error-message" style={{ textAlign: "left" }}>{captchaError}</div>}
        </div>
      </form>
    </Modal>
  );
};

export default FeedbackView;
